import { useState } from "react"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

// Single-line label, click to edit: no markdown, no CodeMirror. For short names, not templates or prose.
// No accept/cancel buttons: enter or clicking away commits, escape discards
export function EditableLabel({ value, onChange, placeholder = "Click to edit", className }: Props) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(value)

  function start() {
    setDraft(value)
    setEditing(true)
  }

  function accept() {
    onChange(draft.trim())
    setEditing(false)
  }

  function cancel() {
    setEditing(false)
  }

  if (!editing) {
    return <span className={cn("cursor-text rounded px-1 hover:bg-muted/50", className)} onClick={start}>
      {value || <span className="text-muted-foreground">{placeholder}</span>}
    </span>
  }

  return <Input
    value={draft}
    onChange={e => setDraft(e.target.value)}
    onBlur={accept}
    autoFocus
    onKeyDown={e => { if (e.key === "Enter") accept(); if (e.key === "Escape") cancel() }}
    className={cn("h-7 text-sm", className)}
  />
}
